const PROJECT_CONFIG = {
  base_appkey: {
    // 美信5.0测试 appkey
    base_appkey_test: 'e21c13e0-b57a-49f1-985b-01af30232e1a',
    // 美信5.0 appkey
    base_appkey_pro: '58031799-ea11-4bb7-b3db-68a9b438766c'
  },
  methods: {
    // 服务号接口(MPM模块)
    getArticleDetailMxp: '/mpm/v5/app/article/viewDetailById', // 查询文章详细 // 已用
    queryCommentListMxp: '/mpm/v5/app/h5/comment/query_comment', // 获取评论列表
    createCommentMxpOther: '/mpm/v5/app/h5/comment/create_comment', // 发评论——第三方平台
    addLikeMxpOther: '/mpm/v5/app/h5/like/add_like', // 第三方平台用户点赞
    cancelLikeMxp: '/mpm/v5/app/h5/like/cancle_like', // 取消点赞
    // 测试环境头像
    headImgUrl: '/muc/v5/app/emp/getUserHeadPhoto?appKey=e21c13e0-b57a-49f1-985b-01af30232e1a&uid=', // 头像
    // uat环境头像
    // headImgUrl: '/muc/v5/app/emp/getUserHeadPhoto?appKey=58031799-ea11-4bb7-b3db-68a9b438766c&uid=',
    // 生产环境头像
    // headImgUrl: '/muc/v5/app/emp/getUserHeadPhoto?appKey=58031799-ea11-4bb7-b3db-68a9b438766c&uid=',
    getListByCategoryId: '/mpm/v5/console/msg/imgtext_mng',
    // 资讯中心新增接口(NMC模块)
    getContentDetail: '/nmc/v5/app/material/submit/get', // 获取资讯详情
    previewContent: '/nmc/v5/console/material/preview', // 预览资讯
    // 资讯中心与服务号混用接口(mpm/v5/nmc)
    getContentQueryCommentList: '/mpm/v5/app/nmc/comment/query_comment', // 资讯评论列表
    checkHasClicked: '/mpm/v5/app/nmc/save/checkHasClicked', // 资讯检验用户是否已经收藏点赞
    contentReadAdd: '/mpm/v5/app/nmc/article/articleReadAdd', // 资讯已读接口
    contentLikeAdd: '/mpm/v5/nmc/like/add_like', // 资讯点赞接口
    contentLikeCancel: '/mpm/v5/nmc/like/cancle_like', // 资讯取消点赞接口
    contentFavoriteAdd: '/mpm/v5/app/nmc/save/add_save', // 资讯收藏接口
    contentFavoriteCancel: '/mpm/v5/app/nmc/save/cancle_save', // 资讯取消收藏
    contentCommentCreate: '/mpm/v5/app/nmc/comment/create_comment', // 资讯创建评论
    getmaterialListByTag: '/nmc/v5/console/material/previewByMaterialTag', // 资讯标签列表查询
    addReadedMxpOther: '/mpm/v5/app/article/articleReadAdd' // 资讯中心阅读+1
  },
  externalUrl: 'https://mapnew5sit.midea.com/mxh5/h5-pass-info-center-mc/#/' // 资讯中心轻应用地址
}

export default PROJECT_CONFIG
